import { DARK_YELLOW_COLOR } from '../../../../const/color-const';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from '@material-ui/data-grid';
import CommonButton from '../../../common/CommonButton';
import { ExpandMore, Tune } from '@material-ui/icons';
import { CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { downloadTransactionFile } from '../../../../actions/sie4-actions';
import { FormattedMessage } from 'react-intl';
import { FileDownload } from '@mui/icons-material';

export const SIE4_TRANSACTION_ID = 'Transaktions-ID';
export const SIE4_PAYMENT_TYPE_INT = '_PaymentTypeInt';

export const SIE4_TRANSACTION_TYPE = 'Transaktionstyp';
export const SIE4_INVOICE = 'Kvitto/Faktura';
export const SIE4_TRANSACTION_NUMBER = 'Nummer';
export const SIE4_TRANSACTION_DATE = 'Datum & tid';
export const SIE4_EMPLOYEE_NAME = 'Personalnamn';
export const SIE4_EMPLOYEE_NUMBER = 'Personalnr.';
export const SIE4_ROW_TYPE = 'Radtyp';
export const SIE4_PAYMENT_TYPE = 'Betalningstyp';
export const SIE4_AMOUNT_PAID = 'Summa betalt';
export const SIE4_GIFTCARD_NUMBER = 'Presentkortsnummer';
export const SIE4_CATEGORY = 'Kategori';
export const SIE4_ITEM_NAME = 'Beskrivning';
export const SIE4_QUANTITY = 'Antal';
export const SIE4_TOTAL_INCL_VAT = 'Totalt pris inkl. moms';
export const SIE4_TOTAL_EXCL_VAT = 'Totalt pris exkl. moms';
export const SIE4_TOTAL_VAT = 'Total moms';
export const SIE4_VAT = 'Momssats (%)';
export const SIE4_TOTAL_DISCOUNT_INCL_VAT = 'Total rabatt inkl. moms';
export const SIE4_TOTAL_PURCHASE_INCL_VAT = 'Totalt inköpspris exkl. moms';
export const SIE4_TOTAL_PROFIT_EXCL_VAT = 'Total vinst exkl. moms';
export const SIE4_PAYMENT_ACCOUNT_NUMBER = '_PaymentAccountNumber';
export const SIE4_ITEM_ACCOUNT_NUMBER = '_ItemAccountNumber';
export const SIE4_EXCLUDED_ITEM = '_IsExcludedItem';
export const SIE4_CARD_TYPE = 'Korttyp';

export const getSie4HeaderTitle = (formatMessage, header) => {
  // eslint-disable-next-line default-case
  switch (header) {
    case SIE4_TRANSACTION_TYPE:
      return formatMessage({ id: 'report.sie4.type', defaultMessage: 'Transaction type' });
    case SIE4_INVOICE:
      return formatMessage({ id: 'report.sie4.invoice', defaultMessage: 'Receipt/Invoice' });
    case SIE4_TRANSACTION_NUMBER:
      return formatMessage({ id: 'report.sie4.number', defaultMessage: 'Transaction number' });
    case SIE4_TRANSACTION_DATE:
      return formatMessage({ id: 'report.sie4.datum', defaultMessage: 'Date & time' });
    case SIE4_EMPLOYEE_NAME:
      return formatMessage({ id: 'report.sie4.employee.name', defaultMessage: 'Employee name' });
    case SIE4_EMPLOYEE_NUMBER:
      return formatMessage({ id: 'report.sie4.employee.number', defaultMessage: 'Employee nr.' });
    case SIE4_ROW_TYPE:
      return formatMessage({ id: 'report.sie4.row.type', defaultMessage: 'Row type' });
    case SIE4_PAYMENT_TYPE:
      return formatMessage({ id: 'report.sie4.payment.type', defaultMessage: 'Payment type' });
    case SIE4_AMOUNT_PAID:
      return formatMessage({ id: 'report.sie4.amount.paid', defaultMessage: 'Amount paid' });
    case SIE4_GIFTCARD_NUMBER:
      return formatMessage({ id: 'report.sie4.giftcard.number', defaultMessage: 'Giftcard nr.' });
    case SIE4_CATEGORY:
      return formatMessage({ id: 'report.sie4.category', defaultMessage: 'Category' });
    case SIE4_ITEM_NAME:
      return formatMessage({ id: 'report.sie4.item.name', defaultMessage: 'Item name' });
    case SIE4_QUANTITY:
      return formatMessage({ id: 'report.sie4.quantity', defaultMessage: 'Quantity' });
    case SIE4_TOTAL_INCL_VAT:
      return formatMessage({ id: 'report.sie4.total.incl.VAT', defaultMessage: 'Total price incl. VAT' });
    case SIE4_TOTAL_EXCL_VAT:
      return formatMessage({ id: 'report.sie4.total.excl.VAT', defaultMessage: 'Total price excl. VAT' });
    case SIE4_TOTAL_VAT:
      return formatMessage({ id: 'report.sie4.total.VAT', defaultMessage: 'Total VAT' });
    case SIE4_VAT:
      return formatMessage({ id: 'report.sie4.VAT', defaultMessage: 'VAT (%)' });
    case SIE4_TOTAL_DISCOUNT_INCL_VAT:
      return formatMessage({ id: 'report.sie4.total.discount.incl.VAT', defaultMessage: 'Total discount incl. VAT' });
    case SIE4_TOTAL_PURCHASE_INCL_VAT:
      return formatMessage({
        id: 'report.sie4.total.purchase.excl.VAT',
        defaultMessage: 'Total purchase price excl. VAT',
      });
    case SIE4_TOTAL_PROFIT_EXCL_VAT:
      return formatMessage({ id: 'report.sie4.total.profit.excl.VAT', defaultMessage: 'Total profit excl. VAT' });
    case SIE4_PAYMENT_ACCOUNT_NUMBER:
      return formatMessage({ id: 'report.sie4.payment.account.number', defaultMessage: 'Payment account nr.' });
    case SIE4_ITEM_ACCOUNT_NUMBER:
      return formatMessage({ id: 'report.sie4.item.account.number', defaultMessage: 'Item account nr.' });
    case SIE4_EXCLUDED_ITEM:
      return formatMessage({ id: 'report.sie4.excluded.item', defaultMessage: 'Excluded item' });
    case SIE4_CARD_TYPE:
      return formatMessage({ id: 'report.sie4.card.type', defaultMessage: 'Card' });
    default:
      return header;
  }
};

export const HIDDEN_COLUMNS = [SIE4_TRANSACTION_ID, SIE4_PAYMENT_TYPE_INT];

export const DownloadToolbar = ({
                                  reportName,
                                  formValues,
                                  machinesOptions,
                                  setDownloadProgress,
                                  downloadProgress,
                                  downloadTransactionFileForSie4,
                                  downloadTransactionFileForExcel,
                                  renderSie4Download,
                                }) => {
  const isDisabled = downloadProgress === 0;
  const [isDownloading, setDownloading] = useState(false);
  
  const downloadBtnStyling = {
    fontSize: 13,
    padding: '2px 18px 2px 6px',
    textTransform: 'uppercase',
    border: `1px solid ${DARK_YELLOW_COLOR}`,
  };
  
  const handleDownload = (type) => {
    return downloadTransactionFile(
      reportName,
      formValues,
      machinesOptions,
      type,
      setDownloadProgress,
      downloadTransactionFileForSie4,
      downloadTransactionFileForExcel,
      setDownloading,
    );
  };
  
  return (
    <div>
      <GridToolbarContainer>
        <GridToolbarColumnsButton endIcon={<ExpandMore />} />
      
        <GridToolbarFilterButton
          componentsProps={{
            button: {
              startIcon: <Tune />,
              endIcon: <ExpandMore />,
            },
          }}
        />
      
        <GridToolbarDensitySelector endIcon={<ExpandMore />} />
  
        {renderSie4Download && <CommonButton
          type="download"
          label={'Sie4'}
          style={downloadBtnStyling}
          disabled={isDisabled || isDownloading}
          startIcon={<FileDownload />}
          onClick={() => handleDownload('se')}>
        </CommonButton>}
      
        <CommonButton
          size={'small'}
          type="download"
          label={'Excel'}
          style={downloadBtnStyling}
          disabled={isDisabled || isDownloading}
          startIcon={<FileDownload />}
          onClick={() => handleDownload('excel')}>
        </CommonButton>
      
        {isDownloading && <span><FormattedMessage
          id="downloading.file"
          defaultMessage="Downloading"
        /></span>}
        {(isDownloading || isDisabled) && <CircularProgress size={20} color={'inherit'} style={{ marginLeft: 10 }} />}
      </GridToolbarContainer>
    </div>
  );
};